import type { RootState } from 'Data/Store/Store';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import { setSelectedCarrierAction } from './SetSelectedCarrierAction';
import { clearOrderAction } from './ClearOrderAction';
import { IOrderStore, OrderState, OrderItemSummary } from '@model/Order.model';
import { IDeliveryAddressView, IDeliveryCarrier } from '@model/DeliveryAddress.model';
import { setSelectedPaymentMethodAction } from './SetSelectedPaymentMethodAction';
import { IPaymentMethodView } from '@model/PaymentMethod.model';
import { setOrderItemsAction } from './SetOrderItemsAction';
import { setSelectedDeliveryAddressAction } from './SetSelectedDeliveryAddressAction';

const orderSelector = (state: RootState) => state.orderReducer;

export const OrderStoreImplementation = (): IOrderStore => {
  const dispatch = useDispatch();
  const orderState = useSelector<RootState, OrderState>(orderSelector);

  const setSelectedDeliveryCarrier = useCallback(
    (carrier: IDeliveryCarrier | null) => setSelectedCarrierAction(carrier)(dispatch),
    [dispatch]
  );

  const setSelectedPaymentMethod = useCallback(
    (method: IPaymentMethodView | null) => setSelectedPaymentMethodAction(method)(dispatch),
    [dispatch]
  );
  const setOrderItems = useCallback(
    (items: OrderItemSummary[]) => setOrderItemsAction(items)(dispatch),
    [dispatch]
  );

  const setSelectedDeliveryAddress = useCallback(
    (address: IDeliveryAddressView | null) => setSelectedDeliveryAddressAction(address)(dispatch),
    [dispatch]
  );
  const clearOrder = useCallback(() => clearOrderAction()(dispatch), [dispatch]);

  return {
    orderState,
    selectedDeliveryAddress: orderState?.selectedDeliveryAddress ?? null,
    setSelectedDeliveryAddress,
    selectedDeliveryCarrier: orderState?.selectedDeliveryCarrier ?? null,
    setSelectedDeliveryCarrier,
    selectedPaymentMethod: orderState?.selectedPaymentMethod ?? null,
    setSelectedPaymentMethod,
    orderItems: orderState?.items ?? [],
    setOrderItems,
    clearOrder,
  };
};
